var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, ComponentRegistry } from 'libs/components';
import { Provider } from 'libs/provider';
import { YoutubeIframeApiLoader } from 'libs/youtube-iframe-api-loader';
var AboutVideo = /** @class */ (function (_super) {
    __extends(AboutVideo, _super);
    function AboutVideo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isPlayerReady = false;
        _this.requestPlayBeforeFinishedLoading = false;
        return _this;
    }
    AboutVideo.prototype.getDependencies = function () {
        this.youtubeIframeApiLoader = Provider.get(YoutubeIframeApiLoader);
    };
    AboutVideo.prototype.onInit = function () {
        var _this = this;
        this.getElements();
        this.readData();
        this.registerListeners();
        this.youtubeIframeApiLoader.isReady.subscribe(function (isReady) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isReady) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.createPlayer()];
                    case 1:
                        _a.sent();
                        this.isPlayerReady = true;
                        if (this.requestPlayBeforeFinishedLoading) {
                            this.player.playVideo();
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        this.hostClass('about-video--stopped', true);
    };
    AboutVideo.prototype.getElements = function () {
        this.videoPlayerContainer = this.host.querySelector('#player');
        this.cover = this.host.querySelector('[data-video-cover]');
    };
    AboutVideo.prototype.readData = function () {
        this.videoId = this.videoPlayerContainer.getAttribute('data-video');
    };
    AboutVideo.prototype.registerListeners = function () {
        var _this = this;
        this.cover.addEventListener('click', function () {
            if (!_this.isPlayerReady) {
                _this.requestPlayBeforeFinishedLoading = true;
            }
            else {
                _this.player.playVideo();
            }
        });
    };
    AboutVideo.prototype.createPlayer = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.player = new YT.Player(_this.videoPlayerContainer, {
                height: '360',
                width: '240',
                videoId: _this.videoId,
                playerVars: {
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                },
                events: {
                    onReady: function () {
                        _this.hostClass('about-video--stopped', true);
                        resolve();
                    },
                    onStateChange: function (event) {
                        _this.onPlayerStateChange(event);
                    },
                },
            });
        });
    };
    AboutVideo.prototype.onPlayerStateChange = function (event) {
        switch (event.data) {
            case YT.PlayerState.ENDED:
                this.hostClass('about-video--stopped', true);
                break;
            case YT.PlayerState.PLAYING:
                this.hostClass('about-video--stopped', false);
                break;
        }
    };
    return AboutVideo;
}(Component));
export { AboutVideo };
ComponentRegistry.register('.about-video', AboutVideo);
